import { Step } from 'react-joyride';
import { translate } from '../../../i18n';

export const TIME_WINDOWS_TOUR_ID = 'time-windows';

export function timeWindowsTourSteps(): Step[] {
  return [
    {
      target: '[data-tour="time-window-groups"]',
      title: translate('walkthrough.time_windows_groups_title'),
      content: translate('walkthrough.time_windows_groups_content'),
      disableBeacon: true,
    },
    {
      target: '[data-tour="time-window-slots"]',
      title: translate('walkthrough.time_windows_slots_title'),
      content: translate('walkthrough.time_windows_slots_content'),
    },
  ];
}
